import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Tooltip } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { useState, useEffect } from "react";
import { globalGetService, globalPostService, globalPutService } from "../../../../globalServices";
import { checkApiStatus } from "../../../utils_v2";
import { trackActivity } from "../../../../utils/mixpanel";
import { useSnackbar } from "notistack";
import { PageLoader } from "../../../shared_elements";
import { regexConstants } from "../../../../constants/regEx";
import InfoIcon from '@material-ui/icons/Info';
import ErrorPopUp from "../../../shared_elements/ErrorPopUp";

const AddEditEngineTypes = ({ params, toggleModalFn, addEditEngineTypes, modeType, getResponseBack }) => {
    const [data, setData] = useState(addEditEngineTypes?.data);
    const [error, setError] = useState({ modal: false, data: null })
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [aircraftTypeInfo, setAircraftTypeInfo] = useState([]);
    const [thrustInfo, setThrustInfo] = useState([]);
    const [pltConstants, setPltConstants] = useState([])
    const [enginefamilyInfo, setEnginefamilyInfo] = useState([]);
    const [moduleData, setModuleData] = useState([]);

    useEffect(() => {
        getPltConstants();
        if (modeType === 'add' || modeType === 'edit') {
            getAircraftType();
            getEngineFamily();
        }
    }, []);

    useEffect(() => {
        if (modeType === 'edit' && data?.engine_family && moduleData?.length > 0) {
            const selectedModule = moduleData.find(module => module.id === data?.engine_family?.id);
            const trusList = selectedModule?.thrust?.map(item => ({
                id: item?.id,
                name: item?.name
            })) || [];
            setThrustInfo(trusList);
        }
    }, [modeType, data?.engine_family, moduleData]);

    const getPltConstants = () => {
        globalPostService('console/get-constants/', { constant_types: ['aircraft_body_type'] })
            .then(response => {
                if (checkApiStatus(response)) {
                    setPltConstants(response.data.data)
                }
            })
    }

   const onFieldChange = (key, value) => {
        let updatedData = { ...data, [key]: value };
        if (key === 'engine_family') {
            const selectedModule = moduleData.find(module => module.id === value?.id);
            const trusList = selectedModule?.thrust?.map(item => ({
                id: item?.id,
                name: item?.name
            })) || [];

            setThrustInfo(trusList);
            updatedData['thrust'] = null;
        }
        setData(updatedData);
    };

    const getEngineFamily = () => {
            globalGetService(`config-data/engine-families/?lite=true`)
                .then(response => {
                    if (checkApiStatus(response)) {
                        let enginefamilyInfo = [];
                        let descriptionList = [];
    
                        const data = response?.data?.data;
                        data.map((item) => {
                            enginefamilyInfo.push({ id: item?.id, name: item?.name });
                        });
                        setEnginefamilyInfo(enginefamilyInfo);
                        setModuleData(data)
                    }
                })
        }

    const getAircraftType = () => {
        globalGetService(`config-data/aircraft-type/?lite=true`)
            .then(response => {
                if (checkApiStatus(response)) {
                    let aircraftTypeInfo = [];
                    const data = response?.data?.data;
                    data && data.map((item) => {
                        aircraftTypeInfo.push({ id: item?.id, name: item?.name })
                    });
                    setAircraftTypeInfo(aircraftTypeInfo);
                }
            })
    }

    const isDataChanged = () => {
        const originalData = addEditEngineTypes?.data || {};

        const getIdArray = (arr) => (arr || []).map(item => item?.id).sort();

        const currentIds = getIdArray(data?.aircraft_type);
        const originalIds = getIdArray(originalData?.aircraft_type);
 
        const areLinkedTypesSame = JSON.stringify(currentIds) === JSON.stringify(originalIds);

        return (
            data?.name !== originalData?.name ||
            !areLinkedTypesSame ||
            data?.engine_family?.id !== originalData?.engine_family?.id ||
            data?.aircraft_body_type?.label !== originalData?.aircraft_body_type?.label||
            data?.svc_escalation !== originalData?.svc_escalation ||
            data?.low_escalation !== originalData?.low_escalation ||
            data?.svc_interval !== originalData?.svc_interval ||
            data?.low_interval !== originalData?.low_interval || 
            data?.thrust?.id !== originalData?.thrust?.id ||
            data?.remarks !== originalData?.remarks
        );
    };

    const onAddEditEngineTypes = () => {

        let validationInputs = {
            name: data?.name?.trim() ? '' : "Please enter Engine Type Name",
            engine_family: data?.engine_family ? '' : "Please select Engine Family",
            aircraft_type: data?.aircraft_type ? '' : "Please Select Aircraft Type",
            svc_escalation: data?.svc_escalation <= 100 ? '' : "SVC Escalation can't exceed 100%",
            low_escalation: data?.low_escalation <= 100 ? '' : "LOW Escalation can't exceed 100%",
            svc_interval: data?.svc_interval <= 1000000 ? '' : "SVC Interval can't exceed 1000000",
            low_interval: data?.low_interval <= 1000000 ? '' : "LOW Interval can't exceed 1000000"
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);

            let payload = Object.assign({}, data);

            payload = {
                id: payload?.id ? payload?.id : null,
                name: payload?.name ? payload?.name : null,
                aircraft_body_type: payload?.aircraft_body_type ? payload?.aircraft_body_type : {value: 3, label: '--N/A--'},
                engine_family: payload?.engine_family ? payload?.engine_family : null,
                aircraft_type: payload?.aircraft_type ? payload?.aircraft_type : [],
                svc_escalation: payload?.svc_escalation ? payload?.svc_escalation : null,
                svc_interval: payload?.svc_interval ? payload?.svc_interval : null,
                low_escalation: payload?.low_escalation ? payload?.low_escalation : null,
                low_interval: payload?.low_interval ? payload?.low_interval : null,
                remarks: payload?.remarks ? payload?.remarks : '',
                thrust: payload?.thrust?.id ? payload?.thrust?.id : null
            }

            const apiUrl = data?.id ? `config-data/engine-type/${data.id}/` : `config-data/engine-type/`;
            const apiMethod = data?.id ? globalPutService : globalPostService;
            apiMethod(apiUrl, [payload])
                .then((response) => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        toggleModalFn();
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Console Management', {
                            event_desc: data?.id ? 'Engine Types Updated Successfully' : 'Engine Types Added Successfully',
                            page_title: 'Config Data : Engine Types',
                            event_type: data?.id ? 'Item Updated' : 'Item Added',
                            updated_id: data?.id || null,
                            success_msg: response?.data?.message
                        })
                    } else {
                        getResponseBack();
                        setError({ modal: true, data: response?.data?.error_details })
                        setLoading(false);
                        trackActivity('Console Management', {
                            event_desc: data?.id ? 'Engine Types Updation Failed' : 'Engine Types Added Failed',
                            page_title: 'Config Data : Engine Types',
                            event_type: data?.id ? 'Item Updated' : 'Item Added',
                            updated_id: data?.id || null,
                            error_msg: response?.data?.message
                        })
                    }
                })
        } else {
            setError(validationInputs);
        }
    }

    return (
        <>
            <Dialog
                open={true}
                className='console-management-modal'
            >
                <DialogTitle id="scroll-dialog-title">
                    {modeType === 'edit' ? 'Edit' : modeType === 'view' ? 'Veiw' : 'Add'} Engine Type
                </DialogTitle>
                <DialogContent dividers>
                    <div>
                        <Grid container spacing={1}>
                            <Grid item md={6}>
                                <TextField
                                    name='name'
                                    label='Name'
                                    disabled={modeType === 'view'}
                                    required
                                    value={data?.name || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 150 }}
                                    onChange={(e) => onFieldChange('name', e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                    error={error?.name || ''}
                                    helperText={error?.name || ''}
                                    onFocus={() => setError({ ...error, name: '' })}
                                />
                            </Grid>
                            <Grid item md={6} >
                                <Autocomplete
                                    options={(enginefamilyInfo || []).filter((item) => item.id !== data?.engine_family?.id)}
                                    getOptionLabel={option => option?.name || ''}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    id="engine_family"
                                    disabled={modeType === 'view'}
                                    value={data?.engine_family || null}
                                    disableClearable={true}
                                    onFocus={() => setError({ ...error, engine_family: '' })}
                                    onChange={(e, value) => { onFieldChange('engine_family', value); }}
                                    renderInput={params => <TextField placeholder={'Please select Engine Family'}  {...params} label={'Engine Family'} error={error?.engine_family || ''} helperText={error?.engine_family || ''} margin="normal" required fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                />
                            </Grid>
                            <Grid item md={6} >
                                <Autocomplete
                                    getOptionLabel={option => option?.label}
                                    options={pltConstants?.filter(optionItem => optionItem?.type === 'aircraft_body_type')}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    id="aircraft_body_type"
                                    disabled={modeType === 'view'}
                                    value={data?.aircraft_body_type || {value: 3, label: '--N/A--'}}
                                    onChange={(e, value) => { onFieldChange('aircraft_body_type', value); }}
                                    renderInput={params => <TextField placeholder={'Please select Aircraft Body Type'}  {...params} label={'Aircraft Body Type'} margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                />
                            </Grid>
                            <Grid item md={6} >
                                {modeType === 'view' ? 
                                <TextField
                                    name='aircraft_type'
                                    label='Aircraft Type'
                                    disabled
                                    value={data?.aircraft_type?.map((item) => item.name).join(', ') || ''}
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                /> :
                                    <Autocomplete
                                        options={aircraftTypeInfo.filter((item) => !(data?.aircraft_type || []).some((selected) => selected.id === item.id))}
                                        getOptionLabel={option => option?.name}
                                        isOptionEqualToValue={(option, value) => option.id === value?.id}
                                        id="aircraft_type"
                                        multiple={true}
                                        disabled={modeType === 'view'}
                                        value={data?.aircraft_type || []}
                                        onChange={(e, value) => { onFieldChange('aircraft_type', value); }}
                                        renderInput={params => <TextField placeholder={modeType === 'view' ? '' : 'Please select Aircraft Type'}  {...params} label={'Aircraft Type'} margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                    />}
                            </Grid>
                            <Grid item md={6} >
                                <TextField
                                    name='svc_escalation'
                                    label={
                                        <div style={{ display: 'flex', alignItems: 'center' }}>SVC Escalation(%)
                                            <Tooltip title={`SVC Escalation is Rounded off to 5 decimal numberb (eg:1.23456).`} placement="top-start" arrow >
                                                <InfoIcon fontSize="small" style={{ verticalAlign: 'bottom', marginLeft: '3px', color: "#989696" }} />
                                            </Tooltip>
                                        </div>
                                    }
                                    disabled={modeType === 'view'}
                                    value={data?.svc_escalation || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 7 }}
                                    onChange={(e) => regexConstants.numberWithDot5.test(e.target.value) ? onFieldChange('svc_escalation', e.target.value) : e.preventDefault}
                                    InputLabelProps={{ shrink: true, style: { pointerEvents: "auto" } }}
                                    variant='outlined'
                                    error={error?.svc_escalation}
                                    helperText={error?.svc_escalation}
                                    onFocus={() => setError({ ...error, svc_escalation: '' })}
                                />
                            </Grid>
                            <Grid item md={6} >
                                <TextField
                                    name='svc_interval'
                                    label={
                                        <div style={{ display: 'flex', alignItems: 'center' }}>SVC Interval
                                            <Tooltip title={`SVC Interval is Rounded off to 6 decimal number(eg:1.234567).`} placement="top-end" arrow >
                                                <InfoIcon fontSize="small" style={{ verticalAlign: 'bottom', marginLeft: '3px', color: "#989696" }} />
                                            </Tooltip>
                                        </div>
                                    }
                                    disabled={modeType === 'view'}
                                    value={data?.svc_interval || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 12 }}
                                    onChange={(e) => regexConstants.numberWithDot6.test(e.target.value) ? onFieldChange('svc_interval', e.target.value) : e.preventDefault}
                                    InputLabelProps={{ shrink: true, style: { pointerEvents: "auto" } }}
                                    variant='outlined'
                                    error={error?.svc_interval}
                                    helperText={error?.svc_interval}
                                    onFocus={() => setError({ ...error, svc_interval: '' })}
                                />
                            </Grid>
                            <Grid item md={6} >
                                <TextField
                                    name='low_escalation'
                                    label={
                                        <div style={{ display: 'flex', alignItems: 'center' }}>LOW Escalation(%)
                                            <Tooltip title={`LOW Escalation is Rounded off to 5 decimal number (eg:1.23456).`} placement="top-start" arrow >
                                                <InfoIcon fontSize="small" style={{ verticalAlign: 'bottom', marginLeft: '3px', color: "#989696" }} />
                                            </Tooltip>
                                        </div>
                                    }
                                    disabled={modeType === 'view'}
                                    value={data?.low_escalation || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 7 }}
                                    onChange={(e) => regexConstants.numberWithDot5.test(e.target.value) ? onFieldChange('low_escalation', e.target.value) : e.preventDefault}
                                    InputLabelProps={{ shrink: true, style: { pointerEvents: "auto" } }}
                                    variant='outlined'
                                    error={error?.low_escalation}
                                    helperText={error?.low_escalation}
                                    onFocus={() => setError({ ...error, low_escalation: '' })}
                                />
                            </Grid>
                            <Grid item md={6} >
                                <TextField
                                    name='low_interval'
                                    label={
                                        <div style={{ display: 'flex', alignItems: 'center' }}>LOW Interval
                                            <Tooltip title={`LOW Interval is Rounded off to 6 decimal number(eg:1.234567).`} placement="top-end" arrow >
                                                <InfoIcon fontSize="small" style={{ verticalAlign: 'bottom', marginLeft: '3px', color: "#989696" }} />
                                            </Tooltip>
                                        </div>
                                    }
                                    disabled={modeType === 'view'}
                                    value={data?.low_interval || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 12 }}
                                    onChange={(e) => regexConstants.numberWithDot6.test(e.target.value) ? onFieldChange('low_interval', e.target.value) : e.preventDefault}
                                    InputLabelProps={{ shrink: true, style: { pointerEvents: "auto" } }}
                                    variant='outlined'
                                    error={error?.low_interval}
                                    helperText={error?.low_interval}
                                    onFocus={() => setError({ ...error, low_interval: '' })}
                                />
                            </Grid>
                            <Grid item md={6} >
                                <Autocomplete
                                    options={(thrustInfo || []).filter(item => item.id !== data?.thrust?.id)}
                                    getOptionLabel={option => option?.name || ''}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    id="thrust"
                                    disabled={modeType === 'view' || !data?.engine_family}
                                    value={data?.thrust || null}
                                    onFocus={() => setError({ ...error, thrust: '' })}
                                    onChange={(e, value) => { onFieldChange('thrust', value); }}
                                    renderInput={params => <TextField placeholder={'Please select thrust'}  {...params} label={'Thrust'} error={error?.thrust || ''} helperText={error?.thrust || ''} margin="normal" required fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                />
                            </Grid>
                            <Grid item md={12} >
                                <TextField
                                    name='remarks'
                                    label='Remarks'
                                    disabled={modeType === 'view'}
                                    value={data?.remarks || ''}
                                    fullWidth
                                    margin="normal"
                                    multiline
                                    rows={3}
                                    inputProps={{ maxLength: 255 }}
                                    onChange={(e) => onFieldChange('remarks', e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                        </Grid>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { toggleModalFn(); trackActivity('Console Management', { page_title: 'Config Data : Engine Types', item_type: 'Cancel Button', event_type: 'Item Clicked', event_desc: `Clicked on Cancel Button from ${modeType === 'add' ? 'Add' : modeType === 'view' ? 'View' : 'Edit'} Engine Types form` }) }} color='primary' size='small' variant='outlined'>Cancel</Button>
                    {modeType === 'view' ? null : <Button onClick={() => { onAddEditEngineTypes(); trackActivity('Console Management', { page_title: 'Config Data : Engine Types', item_type: 'Save Button', event_type: 'Item Clicked', event_desc: `Clicked on Save Button from ${modeType === 'add' ? 'Add' : 'Edit'} Engine Types form` }) }} disabled={isLoading || (modeType === 'edit' && !isDataChanged())} color='primary' size='small' variant='contained'>{isLoading ? <CircularProgress size={24} /> : 'Save'}</Button>}
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
            {error?.data?.map((item) => 
             <ErrorPopUp
               toggleModalFn={() => setError({ modal: false, data: null })}
               modal={error.modal}
               title="Error"
               error={item}
             />)}
        </>
    )
}
export default AddEditEngineTypes;